// External Dependencies
import { useCallback, useEffect } from 'react';

// Internal Dependencies
import { useLogout } from 'hooks/useLogout';
import { useParsedSearch } from 'hooks/useParsedSearch';

// Component Definition
const LogoutPage = (): JSX.Element => {
  const search = useParsedSearch();

  const { redirectUrl } = search;

  const logout = useLogout();

  const handleLogout = useCallback(async () => {
    await logout();

    // A hard refresh helps to ensure we clear all state
    window.location.href = `${window.location.origin}${redirectUrl || '/'}`;
  }, [logout, redirectUrl]);

  useEffect(() => {
    handleLogout();
  }, [handleLogout]);

  return (
    <div>
      Logging out...
    </div>
  );
};

export default LogoutPage;
